<template>

  <bk-view class="storeLocation">
    <bk-view class="top-line"></bk-view>
    <bk-view class="view-store1">
      <bk-view class="view-name">KIS Hair - Spencer St</bk-view>
      <bk-view class="view-location">250 Spencer Street, Shop 4, Melbourne, Victoria Australia</bk-view>
      <bk-view class="book-online" @click="$emit('bookBtnClick')">Book Online</bk-view>
    </bk-view>
    <bk-view class="view-contact">
    </bk-view>
    <bk-view class="view-store2">
      <bk-view class="view-name">KIS Hair on Bourke St</bk-view>
      <bk-view class="view-location">Shop 6/95 Bourke St, Melbourne, Victoria Australia</bk-view>
      <bk-view class="book-online" @click="$emit('bookBtnClick')">Book Online</bk-view>
    </bk-view>

    <bk-view class="copyright">©2019 KIS HAIR SALON</bk-view>
  </bk-view>
</template>

<script>


	export default {
		name: 'storeLocation',
		components: {},
		props: {},
		data () {
			return {};
		},
		computed: {},
		watch: {},
		methods: {},
		mounted () {
		}
	};
</script>

<style scoped lang="less">
@import './storeLocation.less';
</style>